import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/educacion/proteinas-masa-muscular/page.jsx");
